import { render } from "./SensorTableEntry.vue?vue&type=template&id=091b85d2&scoped=true"
import script from "./SensorTableEntry.vue?vue&type=script&lang=js"
export * from "./SensorTableEntry.vue?vue&type=script&lang=js"

import "./SensorTableEntry.vue?vue&type=style&index=0&id=091b85d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091b85d2"]])

export default __exports__